<template>

    <router-link custom
        class="list-item" :class="{ 'clickable': isClickable }"
        :to="{ name: route, params: { id: item.id }}">

        <slot></slot>
        
    </router-link>

</template>

<script>
import Router from '@/router'

import { goTo } from '@/router'

export default {

    props: {

        item: {
            type: Object,
            required: true
        },

        route: {
            type: String,
            default: null,
            required: false
        },
    },

    computed: {
        
        isClickable: function() {
            return ( this.route && this.item.id )
        }
    },

    methods: {       

        view: function(event, href, route) {

            if ( !this.route ) {
                return
            }

            // clique + ctrl
            // clique bouton molette 
            if ( event.ctrlKey === true
                || event.button === 1 ) {
                goTo(href, true)
            }
            
            // clique simple
            else {
               Router.push(route);
            }           
        }
    }
}

</script>

<style>

.list-item {
    display: flex;
    flex-direction: column;
    width: 100%;

    position: relative;

    color: inherit;
    text-decoration: none;
    padding: 1rem 0;
}

.list-item .cell {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.list-item .cell.cell--main {
    font-size: 150%;
    line-height: 3rem; 
    overflow: hidden;
    text-overflow: ellipsis; 
}

.list-item .cell.cell--actions {
    display: none;
}

.list-item .cell.cell--actions > .button {
    margin: 0;
}

.list-item .cell.cell--date {
    opacity: 0.5;
}

.list-item .cell.cell--price {
    font-size: 130%;
    text-align: right;
    justify-content: flex-end;
}

.list-item .cell.cell--qty:before {
    /* content: 'x'; #182 */
}

.list-item .cell.cell--secondary {
    display: none;
}

.list-item .cell.cell--state {
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    display: block;
    overflow: hidden;
}

.list-item .cell .cell__label {
      margin-right: 0.35rem;
}

.list-item .cell .address {
    font-size: 80%;
    margin: 0;
}

@media screen and (min-width: 800px) {

    .list-item {
        flex-direction: row;
        line-height: 3rem;
        padding: 0;
        align-items: center;
    }   

    .list-item.clickable:hover,
    .list-item.clickable:hover > a {
        color: rgb(0, 0, 0);
        cursor: pointer;
        background-color: rgba(13, 197, 193, 0.7);
    }

    .list-item .cell {
        line-height: 1.1em;
    }

    .list-item .cell.cell--main {
        font-weight: 700;
        font-size: 100%;
        line-height: inherit;
    }

    .list-item .cell.cell--actions {
        display: flex;
    }

    .list-item .cell.cell--date {
        opacity: 1;
    }

    .list-item .cell.cell--price {
        font-size: inherit;
        text-align: inherit;
        justify-content: flex-start;
    }

    .list-item .cell.cell--secondary {
        display: inherit;
        overflow: hidden;
        display: inline;
        text-overflow: ellipsis; 
    }

    .list-item .cell.cell--state {
        position: initial;
    }

    .list-item .cell .cell__label {
        display: none;
    }

    .list-item .list-item__cb {
        padding: 0 0.5rem;
        max-width: 3rem;
        width: 3rem;
    }
}

/**
 * Style Card
 */

.list-item.list-item--card {    
    background-color: #f7f7f7;
    border-bottom: 3px solid rgba(0,0,0,0.09);
    padding: 2rem 1.5rem 1.5rem 1.25rem;
}

@media screen and (min-width: 800px) {

    .list-item.list-item--card {
        border: 0 none;
        background-color: transparent;
        padding: 1rem 0;
    }
}

/**
 * Style Inline
 */
.list-item.list-item--inline { 
    flex-direction: row;
    padding: 0;
}

.list-item.list-item--inline .cell:not(.cell--price) {
    margin-right: 1rem;
}

.list-item.list-item--inline .cell.cell--main {
    flex: 3;
}

.list-item.list-item--inline .cell.cell--main,
.list-item.list-item--inline .cell.cell--price {
    font-size: 100%;
}

@media screen and (min-width: 800px) {  

    .list-item.list-item--inline .cell:not(.cell--price) {
        margin-right: 0;
    }

    .list-item.list-item--inline .cell.cell--main {
        flex: 2.5;
    }
}

</style>